module.exports = __webpack_public_path__ + "img/08.01ea5f6a.png";